module.exports = __webpack_public_path__ + "0c4efaa9e81da6e14fdab546026a1554.png";